import React, { useState, useEffect } from "react";
import "./EnvironmentalCampus.scss";

import img from "../../assets/Infrastructure/Environmental Friendly Campus/img (1).jpeg";
import img1 from "../../assets/Infrastructure/Environmental Friendly Campus/img (2).jpeg";
import img2 from "../../assets/Infrastructure/Environmental Friendly Campus/img (3).jpeg";
import img3 from "../../assets/Infrastructure/Environmental Friendly Campus/img (4).jpeg";

const images = [img, img1, img2, img3];

const EnvironmentalCampus = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="eco-campus">
      <div className="container">
        <h1 className="page-title">ENVIRONMENTAL FRIENDLY CAMPUS</h1>

        {/* IMAGE CAROUSEL */}
        <div className="eco-carousel">
          {images.map((img, index) => (
            <div
              key={index}
              className={`slide ${index === current ? "active" : ""}`}
            >
              <img src={img} alt={`Eco Campus ${index + 1}`} />
            </div>
          ))}
        </div>

        {/* CONTENT */}
        <div className="content-card">
          <p className="intro">
            Our college is committed to sustainability and
            environmental stewardship, creating a campus that harmonizes
            education with nature.
          </p>

          <p>
            The campus is thoughtfully designed to be{" "}
            eco-friendly, featuring lush greenery,
            open spaces, and energy-efficient infrastructure that
            promotes a healthy and sustainable learning environment.
          </p>

          <p>
            We actively promote environmental awareness through
            initiatives such as waste reduction practices,
             tree plantation drives, and sustainability programs,
            fostering a strong sense of environmental responsibility among
            students and staff.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EnvironmentalCampus;
